const ITEMS = [
  "hand-poured resin",
  "hand-knotted macramé",
  "small-batch ceramics",
  "slow-burning candles",
  "one of a kind",
  "made slowly",
];

function Row({ hidden }) {
  return (
    <div className="flex shrink-0 items-center" aria-hidden={hidden || undefined}>
      {ITEMS.map((t) => (
        <span key={t} className="flex items-center">
          <span className="whitespace-nowrap px-8 font-display text-5xl font-light italic md:px-12 md:text-7xl">
            {t}
          </span>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            className="shrink-0 text-terracotta"
            fill="currentColor"
            aria-hidden="true"
          >
            <path d="M12 2c1.5 6 4.5 9 10 10-5.5 1-8.5 4-10 10-1.5-6-4.5-9-10-10 5.5-1 8.5-4 10-10z" />
          </svg>
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <section
      className="overflow-hidden border-y border-line bg-cream py-10 md:py-14"
      data-testid="editorial-marquee"
    >
      <div className="marquee-track flex w-max">
        <Row />
        <Row hidden />
      </div>
    </section>
  );
}
